module.exports = __webpack_public_path__ + "img/clock_in_btn.a906877e.png";